import { core } from '@tock/coretypes';
import { noop } from 'es-toolkit';
import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { LoyaltyProgramBalanceRequest } = protos;

export function fetchAnnexCloudBalance(
  subtotalCents: number,
  discountsCents: number,
  guestPatron: core.IPatron
): ApiAction<core.LoyaltyProgramBalance> {
  return {
    TockApi: {
      postProto: '/integrations/annexcloud/balance',
      type: AppConstants.LOYALTY_PROGRAM_FETCH_BALANCE,
      request: LoyaltyProgramBalanceRequest.fromObject({
        subtotalCents,
        discountsCents,
        guestPatron,
      }),
      ignoreNetworkErrors: true,
      onError: noop,
    },
  };
}
